<template>
    <div class="body">
        <div style="padding-top:17vh;display:flex;justify-content: center;align-items: center;flex-wrap: wrap;">
			<span style="width:100vh;margin:0;text-align: center;font-weight: 800; font-size: 56px;color: #fff;text-shadow: #fff 0px 0px 3px,   #fff 0px 0px 2px,   #fff 0px 0px 2px, #000 0px 0px 2px,   #000 0px 0px 2px,   #000 0px 0px 2px;font-family:'Gentium Basic', serif;">2025</span>
			<span style="width:100vh;margin:0;text-align: center;font-weight: 800;font-size: 27px;color: #fff;font-family: 'Eczar', cursive,sans-serif;">富学宝典</span>
			<span style="margin:7px;background:cadetblue;padding: 4px 27px;border-radius: 11px;background: #fad3a2;font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman',cursive, serif; color:#c8332c;font-size:18px;">一月学习报告</span>
			<span style="width:100vh;margin:10px;text-align: center;font-size: 27px;color: #fff;font-family: 'Eczar', cursive,sans-serif;">坚持学习的人永葆青春</span>
        </div>
      
        <div class="form" v-show="playtimeShow">
			<input class="input" placeholder="请输入工号" v-model="thisJobNo" type="text">
			<span class="input-border"></span>
        </div>

        <button v-show="playtimeShow" :style="'margin-top:'+ windowWidth*0.17 +'px;'" @click="sumbitJobNo"> let's go<span></span></button>
        <div class="footer-content">
			<p style="margin: 0;">版权所有：富泰华工业（深圳）有限公司 </p >
			<p style="margin: 0;">备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a ></p >
        </div>
    </div>
</template>
  
<script>
import jieliufa from '@/utils/jieliufa'
export default {
	data() {
		return {
			thisJobNo: '',
			buttonShow: true,
			windowWidth: window.innerHeight,
			playtimeShow: true
		}
	},
	methods: {
		sumbit: jieliufa.throttle(function() {
			/*节流：
			*在规定的时间间隔范围内不会重发触发回调，只有大于时间间隔才会触发回调
			*也就是说，把频发触发变成少量触发
			*/
			this.sumbitJobNo()
		},1000),
		sumbitJobNo() {
			if (!this.thisJobNo) {
				this.$message({
					message: "工号不能为空",
					type: "warning",
					center: true
				})
				return
			}
			this.$emit('inputJobNo',this.thisJobNo)
		},
	},
	created() {}
    }
</script>
  
<style scoped>
.body {
    /* background:linear-gradient(-170deg,#ffa6a2 , #fecc97); */
    background:   url("../../assets/logo1.png") right  top  no-repeat,
                  url("../../assets/25January/bg.jpg")  no-repeat;
      background-size: 110px 35px,cover;
    width: 100%;
    height: 100vh;
}
.form {
    --width-of-input: 270px;
    --border-height: 1px;
    --border-before-color: rgb(146, 62, 220);
    /* --border-after-color: linear-gradient(40deg,#fecc94,#fecc94); */
    position: relative;
    width: var(--width-of-input);
    margin: 0 auto;
    top: 87px;
}
.input {
    color: #fad3a2;
    font-size: 1.1rem;
    background-color: transparent;
    width: 100%;
    box-sizing: border-box;
    padding-inline: 0.5em;
    padding-block: 0.7em;
    border: none;
    border-bottom: #fad3a2 solid 1px;
    font-family: monospace;
}
.input-border {
    position: absolute;
    background: var(--border-after-color);
    width: 0%;
    height: 2px;
    bottom: 0;
    left: 0;
    transition: 0.3s;
}

input:focus {
    outline: none;
}  
  
button {
    width: 7em;
    position: absolute;
    height: 2.5em;
    border: 3px ridge #fad3a2;
    outline: none;
    background-color: transparent;
    color: #fff;
    transition: 1s;
    border-radius: 0.3em;
    font-size: 16px;
    font-weight: bold;
    left: 50%;
    transform: translateX(-50%);
    animation: light 3s infinite;
}
  
@keyframes light {
    0%{
      box-shadow: inset 0px 0px 7px rgb(250, 211, 162);
    }
    50%{
      /* letter-spacing: 0.25em; */
      box-shadow: inset 0px 0px 47px rgb(250, 211, 162);
    }
    100%{
      /* letter-spacing: 0.25em; */
      box-shadow: inset 0px 0px 7px rgb(189, 135, 234);
    }
  }
  
button::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
    transform-origin: center;
}
  
button::before {
    content: "";
    transform-origin: center;
    position: absolute;
    top: 80%;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
} 
.footer-content {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
}
</style>